module.exports = __webpack_public_path__ + "assets/img/27_1255.45ca6587.jpg";